// Copyright (c) 2016 Deere & Company

import {
    addFile,
    deleteFile
} from './file-attachment';
import {
    onCreateClaim,
    updateClaimModalMode,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    readJdpReasons,
    readJdpResolutions
} from './get-jdp-constants';
import {
    resetConfirmationModal,
    setConfirmationModal
} from './confirmation-modal';
import {
    resetJdpClaim,
    resetJdpProductDetails,
    updateCustomerResolutionDropDown,
    updateJdpClaimInputOnBlur,
    updateJdpClaimProperty,
    updateJdpClaimRepairNumber,
    updateJdpClaimType,
    updateJdpClaimWorkOrderOne,
    updateReasonForReturnDropDown,
    updateResponsibleAccountsDropDown,
    updateStickyHeaderVisibility
} from './claim-details';
import {copyAttachments} from '../../../shared/action-creators/copy-attachment';
import {copyClaim} from './copy-claim';
import {createJdpClaim} from './validate-claim';
import {onEditClaim} from '../../../shared/action-creators/edit-claim';
import {readClaimProduct} from './get-product-details';
import {readClaimTypes} from './get-claim-types';
import {readGoodsInstallationVatOptions} from '../../../shared/action-creators/get-goods-installation-vat-options';
import {readJdpClaim} from './get-jdp-claim';
import {readPartDetails} from './get-part-details';
import {resetCkcCustomerFailure} from '../../../../shared/action-creators/customer-failed';
import {resetCustomerDetails} from './reset-customer-details';
import {resetLatestPerUnitMeasurements} from '../../../../shared/action-creators/latest-per-unit-measurements';
import {toggleWarrentyStatusModal} from '../../../shared/action-creators/warranty-status-modal';
import {updateGoodsInstallationVat} from './update-goods-installation-vat';
import {updateIsEditable} from './is-editable';
import {updateSelectedAction} from './update-selected-action';
import {updateTemporaryObjectKey} from './update-temporary-object-key';
import {updateWarranties} from '../../../../product/details/action-creators/warranties';

export default {
    addFile,
    copyAttachments,
    copyClaim,
    createJdpClaim,
    deleteFile,
    onCreateClaim,
    onEditClaim,
    readClaimProduct,
    readClaimTypes,
    readGoodsInstallationVatOptions,
    readJdpClaim,
    readJdpReasons,
    readJdpResolutions,
    readPartDetails,
    resetCkcCustomerFailure,
    resetConfirmationModal,
    resetCustomerDetails,
    resetJdpClaim,
    resetJdpProductDetails,
    resetLatestPerUnitMeasurements,
    setConfirmationModal,
    toggleWarrentyStatusModal,
    updateClaimModalMode,
    updateCreateClaimModalVisibility,
    updateCustomerResolutionDropDown,
    updateGoodsInstallationVat,
    updateIsEditable,
    updateJdpClaimInputOnBlur,
    updateJdpClaimProperty,
    updateJdpClaimRepairNumber,
    updateJdpClaimType,
    updateJdpClaimWorkOrderOne,
    updateReasonForReturnDropDown,
    updateResponsibleAccountsDropDown,
    updateSelectedAction,
    updateStickyHeaderVisibility,
    updateTemporaryObjectKey,
    updateWarranties
};



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/action-creators/index.js